import Smartphones from 'Projects/views/ProjectView/FinanceVisualization/containers/Smartphones'
import Tablets from 'Projects/views/ProjectView/FinanceVisualization/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const FinanceVisualizationView = getCurrentDeviceView(Smartphones, Tablets)

export default FinanceVisualizationView
